// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1p-Iu","paramInput":"JobSimulator_paramInput__WXKbW","input":"JobSimulator_input__1ln_x"};